import * as React from 'react';

import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, Box, IconButton } from '@mui/material';
import { useRecoilValue } from 'recoil';

import { shopAuthContextState } from '@/state/userAuthContext';

import { useNotificationDialog } from './useNotification';
import { useQueryGetNotifications } from './useQueryGetNotifications';

/**
 * 공용 navbar의 알림 아이콘 버튼
 */
export default function NotificationBtn() {
  const { toggleNotification } = useNotificationDialog();
  const shopInfo = useRecoilValue(shopAuthContextState);

  const { data: pollingData } = useQueryGetNotifications(
    shopInfo.shopID,
    { isPolling: true, pageNumber: 1, pageSize: 1, withoutRead: true },
    {
      enabled: !!shopInfo.shopID,
      refetchInterval: 2000,
    },
  );

  const badgeInvisible = React.useMemo(() => (pollingData?.notifications?.length ?? 0) < 1, [pollingData]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', height: '30px' }}>
      <IconButton sx={{ color: 'white', width: 32, height: 32 }} onClick={toggleNotification}>
        <Badge color="primary" badgeContent=" " variant="dot" invisible={badgeInvisible}>
          <NotificationsIcon sx={{ color: 'black' }} />
        </Badge>
      </IconButton>
    </Box>
  );
}
